import { render, staticRenderFns } from "./tobFolderList.vue?vue&type=template&id=157df844&scoped=true&"
import script from "./tobFolderList.vue?vue&type=script&lang=js&"
export * from "./tobFolderList.vue?vue&type=script&lang=js&"
import style0 from "./tobFolderList.vue?vue&type=style&index=0&id=157df844&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157df844",
  null
  
)

export default component.exports